import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, ToggleButton, ToggleButtonGroup, FormControl, FormLabel, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from 'notistack';

import { exportDataHelper } from "../helpers/exportDataHelper";
import { selectLists } from "../reducers/listSlice";
import { selectWells } from "../reducers/wellSlice";
import { ExportDataListsTransferList } from "./ExportDataListsTransferList";
import { ExpandMore, Refresh } from "@mui/icons-material";
import { ExportDataTypeCurvesTransferList } from "./ExportDataTypeCurvesTransferList";
import { getTypeCurveForecast, getTypeCurves, selectTypeCurves } from "../reducers/typeCurveSlice";
import { getGroupWellForecast, getGroupWells, selectGroupWells } from "../reducers/groupWellSlice";
import { ExportDataGroupWellsTransferList } from "./ExportDataGroupWellsTransferList";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { selectUser } from "../reducers/userSlice";
import { selectOptions } from "../reducers/optionsSlice";
// import { selectOptions } from "../reducers/optionsSlice";


export const ExportData = ({ projectName, handleExportDataClose }) => {

  const dispatch = useDispatch();

  const [name, setName] = useState(`${projectName}-${new Date().toISOString().split('T')[0]}`);
  const [type, setType] = useState('csv');
  const [units, setUnits] = useState('metric');
  const [selectedLists, setSelectedLists] = useState([]);
  const [typeCurveIds, setTypeCurveIds] = useState([]);
  const [groupWellIds, setGroupWellIds] = useState([]);
  const [isLoadingTypeCurves, setIsLoadingTypeCurves] = useState(false);
  const [isLoadingGroupWells, setIsLoadingGroupWells] = useState(false);

  const lists = useSelector(selectLists);
  const typeCurves = useSelector(selectTypeCurves);
  const groupWells = useSelector(selectGroupWells);
  const wells = useSelector(selectWells);
  const user = useSelector(selectUser);
  const options = useSelector(selectOptions);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!typeCurveIds || typeCurveIds.length === 0) return;
    for (let typeCurveId of typeCurveIds) {
      console.log('Generating type curve forecast');
      dispatch(getTypeCurveForecast(typeCurves.byId[typeCurveId]));
    };
  }, [typeCurveIds]); //eslint-disable-line

  useEffect(() => {
    if (!groupWellIds || groupWellIds.length === 0) return;
    for (let groupWellId of groupWellIds) {
      console.log('Generating group well forecast');
      dispatch(getGroupWellForecast(groupWells.byId[groupWellId]));
    };
  }, [groupWellIds]); //eslint-disable-line

  return (
    <Dialog
      open={true} 
      onClose={() => handleExportDataClose()}
      fullWidth={true}
      maxWidth="md"
      // style={{backgroundColor: user?.value?.darkMode ? '#121212' : '#f5f5f5'}}
    >
      <DialogTitle>Export Data</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="normal"
          id="name"
          label="File Name"
          type="text"
          fullWidth
          value={name}
          variant="outlined"
          placeholder="File name"
          onChange={e => setName(e.target.value)}
        />

        <FormControl component="fieldset" style={{width: '100%', marginTop: 20, marginBottom: 20}}>
          <FormLabel component="legend" style={{marginBottom: 10}}>Export File Type</FormLabel>
          <ToggleButtonGroup
            value={type}
            exclusive
            onChange={handleType}
            style={{width: '100%'}}
          >
            <ToggleButton value="csv" style={{width: '50%'}} color="primary">
              CSV
            </ToggleButton>
            <ToggleButton value="json" style={{width: '50%'}} disabled color="primary">
              JSON
            </ToggleButton>
          </ToggleButtonGroup>
        </FormControl>

        <FormControl component="fieldset" style={{width: '100%', marginTop: 10, marginBottom: 20}}>
          <FormLabel component="legend" style={{marginBottom: 10}}>Units</FormLabel>
          <ToggleButtonGroup
            value={units}
            exclusive
            onChange={handleUnits}
            style={{width: '100%'}}
          >
            <ToggleButton value="metric" style={{width: '50%'}} color="primary">
              Metric
            </ToggleButton>
            <ToggleButton value="field" style={{width: '50%'}} color="primary">
              Field
            </ToggleButton>
          </ToggleButtonGroup>
        </FormControl>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>Export Well Lists</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ExportDataListsTransferList selectedLists={selectedLists} setSelectedLists={setSelectedLists} />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>Export Type Curves</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Button onClick={e => handleRefreshTypeCurves(e)} startIcon={<Refresh />}>Refresh</Button>

            <ExportDataTypeCurvesTransferList 
              typeCurveIds={typeCurveIds} 
              setTypeCurveIds={setTypeCurveIds} 
              isLoadingData={isLoadingTypeCurves} 
            />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>Export Group Wells</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Button onClick={e => handleRefreshGroupWells(e)} startIcon={<Refresh />}>Refresh</Button>

            <ExportDataGroupWellsTransferList 
              groupWellIds={groupWellIds} 
              setGroupWellIds={setGroupWellIds}
              isLoadingData={isLoadingGroupWells} 
            />
          </AccordionDetails>
        </Accordion>

      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleExportDataClose()} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={() => handleExportDataClick()} 
          variant="contained" 
          color="primary" 
          disabled={selectedLists?.length === 0 && typeCurveIds?.length === 0 && groupWellIds?.length === 0}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS
  function handleRefreshTypeCurves(e) {
    e.stopPropagation();
    setIsLoadingTypeCurves(true);
    dispatch(getTypeCurves({email: user?.value?.email})).then(() => setIsLoadingTypeCurves(false));
  };

  function handleRefreshGroupWells(e) {
    e.stopPropagation();
    setIsLoadingGroupWells(true);
    dispatch(getGroupWells(user?.value?.email)).then(() => setIsLoadingGroupWells(false));
  };

  function handleType(event, newType) {
    newType && setType(newType);
  };

  function handleUnits(event, newUnits) {
    newUnits && setUnits(newUnits);
  };

  function handleExportDataClick() {

    handleExportDataClose();
    const exported = exportDataHelper(name, type, units, [], selectedLists, typeCurveIds, groupWellIds, lists, wells, typeCurves, groupWells, options?.showForecast); // normalization is disabled for the bulk export
    if (exported) {
      enqueueSnackbar(`Data exported successfully`, {variant: 'success'});
      console.log('Data exported successfully');
    };
  };
};